import React from 'react'
import Helmet from 'react-helmet'

import Work from '../components/work'

const human = require('../img/human.jpg')

const LivingProduct = () =>
  <div>

    <Helmet
      title='Living Product Challenge | Cory Schadt'
      bodyAttributes={{
        class: 'inner'
      }}
    />

    <div className='page fade'>
      <div className='container'>
        <div className='content'>
          <h1>Living Product Challenge</h1>
          <div className='text'>
            <p>The Living Product Challenge calls on manufacturers to make their own operations Net Positive with respect to impact categories such as water, energy, climate, waste and ecological impacts.
            </p>
            <p>This site was created to highlight products which meet the Living Product Certification.</p>
            <p>Primary Role:  HTML, CSS, Responsive Design, CSS Animations.</p>
            <p><a className='btn' target='_blank' href='https://ca.humanscale.com/about/living-product-challenge/index.cfm'>View Project</a></p>
          </div>
        </div>
      </div>

      <div className='project-feature'>
        <Work noLink raise laptop screen={human} color='#62E3AC' />
      </div>
    </div>
  </div>
export default LivingProduct



// WEBPACK FOOTER //
// ./src/pages/living-product.js